<template>
    <div class="cooperation-cases">
        <!-- 顶部Banner开始 -->
        <div class="top-banner">
            <img src="../../assets/images/bg-cases-banner.png" alt="" class="center-img">
        </div>
        <!-- 顶部Banner结束 -->
        <!-- 精选案例开始 -->
        <div class="cases-title">精选案例展示</div>
        <div class="cases-desc">从定制样衣到批量大货,全程专业护航,助力客户高效落地服装生产,见证品质与效率双赢</div>
        <div class="list-container">
            <div class="list-box">
                <div class="list-item" v-for="(item,index) in list" :key="index" @click.stop="$router.push({name:'CaseDetail',params:{case_id:item.case_id}})">
                    <img :src="item.main_image|default_img" alt="" class="cover">
                    <div class="list-title">{{item.title}}</div>
                    <div class="list-desc">{{item.description}}</div>
                    <div class="detail-btn" @click.stop="$router.push({name:'CaseDetail',params:{case_id:item.case_id}})">查看详情<img src="../../assets/images/icon-more-cases.png" alt="" class="more-icon"></div>
                </div>
            </div>
            <div class="more-btn" @click="onGetCooperationList">加载更多案例</div>
        </div>
        <!-- 精选案例结束 -->
        <!-- 合作流程开始 -->
        <div class="cooperation-process">
            <div class="process-title">我们的合作流程</div>
            <div class="process-desc">从需求沟通到最终交付,我们提供全程贴心服务,确保每一件服装都完美呈现</div>
            <div class="step-box">
                <div class="step-item">
                    <div class="step-container">
                        <div class="step-counter">1</div>
                        <div class="step-title">设计稿上传</div>
                        <div class="step-content">
                            上传您的服装设计草图、灵感图片或详细图纸。作为我们开启合作的起点。我们的系统支持多种格式，为您提供最大的便捷性。
                        </div>
                    </div>
                </div>
                <div class="step-item">
                    <div class="step-container">
                        <div class="step-counter">2</div>
                        <div class="step-title">需求细节沟通</div>
                        <div class="step-content">
                            专属顾问与您1对1沟通，敲定面料、尺寸等所有细节，确保您的每一个创意细节都被准确理解，并给出专业的实现建议。
                        </div>
                    </div>
                </div>
                <div class="step-item">
                    <div class="step-container">
                        <div class="step-counter">3</div>
                        <div class="step-title">专业定制生产</div>
                        <div class="step-content">
                            专业团队匠心之作，严格把控您所要求的各项工艺。您可以通过个人中心查看生产进度，我们承诺透明化的流程管理。
                        </div>
                    </div>
                </div>
                <div class="step-item">
                    <div class="step-container">
                        <div class="step-counter">4</div>
                        <div class="step-title">成品交付</div>
                        <div class="step-content">
                            产品经过最终的质量检验后，我们会精心包装并安排发货。您将收到一件完全按照您的定制要求的、高品质的成品服装。
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 合作流程结束 -->
        <!-- 客户评价开始 -->
        <div class="custom-evaluation">
            <div class="evaluation-title">客户评价</div>
            <div class="evaluation-desc">听听我们的客户怎么说,他们的成功就是我们最好的证明</div>
            <div class="evaluation-box">
                <div class="evaluation-list">
                    <div class="page-container">
                        <div class="prev" @click="onEvaluationPageClick('prev')">
                            <img src="../../assets/images/icon-prev-cases.png" alt="" class="prev-icon">
                        </div>
                        <div class="next" @click="onEvaluationPageClick('next')">
                            <img src="../../assets/images/icon-next-cases.png" alt="" class="next-icon">
                        </div>
                    </div>
                    <div v-show="!is_loading" class="evaluation-item animate__animated animate__fadeInRight" v-for="(item,index) in evaluation_list" :key="index">
                        <div class="item-container">
                            <div class="user-info">
                                <img :src="item.avatar|default_avatar" alt="" class="user-avatar">
                                <div class="name-job">
                                    <div class="name">{{item.name}}</div>
                                    <div class="job">{{ item.job }}</div>
                                </div>
                            </div>
                            <div class="score-box">
                                <template v-for="(star,i) in stars(item.score)">
                                    <img :key="i" v-if="star.full" src="../../assets/images/icon-star-full.png" alt="" class="score-icon" />
                                    <img :key="i" v-else-if="star.half" src="../../assets/images/icon-star-half.png" alt="" class="score-icon" />
                                    <img :key="i" v-else src="../../assets/images/icon-star-empty.png" alt="" class="score-icon" />
                                </template>
                            </div>
                            <div class="evaluation-content">
                                {{ item.content }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 客户评价结束 -->
        <!-- 底部开始 -->
         <div class="cases-footer">
           <div class="footer-center">
                <div class="main-slogan">让我们一起打造您的品牌成功故事</div>
                <div class="main-desc">无论您是企业客户还是个人客户,我们都能为您提供量身定制的解决方案,助力您在服装市场取得成功.</div>
                <div class="design-btn">开始定制</div>
           </div>
         </div>
        <!-- 底部结束 -->
    </div>
</template>
<script>
import { getCooperationList,getEvaluationList } from '@/api';
export default{
    data(){
        return{
            score:1.5,
            case_page:1,
            case_limit:9,
            evaluation_page:1,
            evaluation_limit:3,
            list:[],
            evaluation_list:[],
            is_loading:false,
            loading_case:false
            // evaluation_count:0,
        }
    },
    computed:{
        
    },
    mounted(){
        Promise.all([
            this.onGetCooperationList(),
            this.onGetEvaluationList()
        ])
    },
    methods:{
        onEvaluationPageClick(type){
            this.evaluation_page = type === 'prev' ? this.evaluation_page - 1 : this.evaluation_page + 1;
            this.onGetEvaluationList();
        },
        async onGetEvaluationList(){
            try{
                const {evaluation_page,evaluation_limit} = this;
                if(evaluation_page < 1){
                    this.evaluation_page = 1;
                    this.$layer.msg('已经是第一页了~');
                    return;
                }
                const param = {};
                param.page = evaluation_page;
                param.limit = evaluation_limit;
                this.is_loading = true;
                const {data} = await getEvaluationList(param);
                console.log('data=>evaluation',data);
                if(!data.list || !data.list.length || data.list.length === 0){
                    this.$layer.msg('- 我也是有底线的 -');
                    this.evaluation_page = evaluation_page == 1 ? 1 : evaluation_page - 1;
                    return;
                }
                this.evaluation_list = data.list;
                // this.evaluation_count = data.count;
            }catch(e){
                console.log('e',e);
            }finally{
                this.is_loading = false;
            }
        },
        async onGetCooperationList(){
            try{
                const {case_page,case_limit,list,loading_case} = this;
                if(loading_case) return;
                this.loading_case = true;
                const param = {};
                param.page = case_page;
                param.limit = case_limit;
                const {data} = await getCooperationList(param);
                if(!data.list || !data.list.length || list.length >= data.count){
                    this.$layer.msg('- 我也是有底线的 -');
                    return;
                }
                this.list = this.list.concat(data.list);
                this.case_page++;
            }catch(e){ 
                console.log('err-case',e);
            }finally{
                this.loading_case = false;
            }
        },
        generateRandomScoreWithDecimal(decimalPlaces = 1) {
            const min = 1;
            const max = 5;
            const randomNum = Math.random() * (max - min) + min;
            console.log('randomNum---',Math.round(randomNum * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces));
            return Math.round(randomNum * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces);
        },
        stars(score) {
            const stars = [];

            // score = this.generateRandomScoreWithDecimal();

            if(!score) return stars;

            // 计算完整的星数
            const fullStars = Math.floor(score);
            // 判断是否需要半星（小数部分大于等于0.5）
            const hasHalfStar = (score - fullStars) >= 0.5;
            
            // 构建5个星的数组
            for (let i = 0; i < 5; i++) {
                if (i < fullStars) {
                    // 完整的实心星
                    stars.push({ full: true, half: false });
                } else if (i === fullStars && hasHalfStar) {
                    // 半星
                    stars.push({ full: false, half: true });
                } else {
                    // 空心星
                    stars.push({ full: false, half: false });
                }
            }
            
            return stars;
        }
    }
}
</script>
<style lang="scss" scoped>
.cooperation-cases{
    width:100%;
    display:flex;
    justify-content:center;
    // flex-wrap:wrap;
    flex-direction:column;
    align-items:center;
    padding-bottom:50px;
    .top-banner{
        width:100%;
        height:450px;
        background-image:url('../../assets/images/bg-cases-bannerbg.jpg');
        background-repeat:no-repeat;
        background-size:100% 100%;
        background-position:center;
        display:flex;
        align-items:center;
        justify-content:center;
        .center-img{
            width:796px;
            height:306px;
        }
    }
    .cases-title{
        color:#1f1f1f;
        font-size:30px;
        font-weight:bold;
        margin-top:49px;
    }
    .cases-desc{
        color:#666666;
        font-size:16px;
        margin-top:19px;
    }
    .list-container{
        width:100%;
        display:flex;
        justify-content:center;
        flex-wrap:wrap;
        .list-box{
            padding:0 10%;
            margin-top:59px;
            display: flex;
            flex-wrap: wrap;
            gap: 30px;
            width:100%;
            .list-item{
                width: 31%;
                cursor:pointer;
                .cover{
                    width: 100%;
                    height:320px;
                    border-radius:5px;
                    object-fit:cover;
                    object-position:center;
                }
                .list-title{
                    margin-top:20px;
                    width:100%;
                    text-overflow:ellipsis;
                    overflow:hidden;
                    white-space:nowrap;
                    color:#1c1f23;
                    font-size:16px;
                    font-weight:bold;
                }
                .list-desc{
                    margin-top:10px;
                    width:100%;
                    text-overflow:ellipsis;
                    overflow:hidden;
                    white-space:nowrap;
                    color:#4d4d4d;
                    font-size:14px;
                }
                .detail-btn{
                    display:flex;
                    align-items:center;
                    color:#4d4d4d;
                    font-size:14px;
                    column-gap:6px;
                    margin-top:17px;
                    .more-icon{
                        width:26px;
                        height:20px;
                    }
                }
            }
        }
        .more-btn{
            width:189px;
            height:52px;
            border:1px solid #333333;
            border-radius:5px;
            text-align:center;
            line-height: 52px;
            color:#1a1a1a;
            font-size:14px;
            cursor:pointer;
            margin-top:65px;
            margin-bottom:59px;
        }
    }
    .cooperation-process{
        width:100%;
        background:#f8f8f8;
        display:flex;
        flex-direction: column;
        align-items:center;
        justify-content:center;
        .process-title{
            color:#1f1f1f;
            font-size:30px;
            font-weight:bold;
            margin-top:53px;
        }
        .process-desc{
            color:#666666;
            margin-top:20px;
            font-size:16px;
        }
        .step-box{
            display:flex;
            column-gap:26px;
            margin-top:50px;
            margin-bottom:81px;
            width:100%;
            padding:0 10%;
            .step-item{
                width:24%;
                background:#ffffff;
                .step-container{
                    padding:30px;
                    display:flex;
                    flex-direction:column;
                    .step-counter{
                        color:#ffffff;
                        font-size:22px;
                        font-weight:bold;
                        width:62px;
                        height:62px;
                        background:#ff5967;
                        border-radius:50%;
                        text-align:center;
                        line-height:62px;
                    }
                    .step-title{
                        color:#1c1f23;
                        font-size:18px;
                        font-weight:bold;
                        margin-top:25px;
                        position:relative;
                        &::after{
                            content:"";
                            position:absolute;
                            width:40px;
                            height:3px;
                            background:#ff5967;
                            // margin-top:12px;
                            bottom:-10px;
                            left:0;
                        }
                    }
                    .step-content{
                        color:#4d4d4d;
                        font-size:14px;
                        margin-top:32px;
                    }
                }
            }
        }
    }
    .custom-evaluation{
        width:100%;
        background:#2a2a2a;
        display:flex;
        flex-direction:column;
        align-items:center;
        justify-content:center;
        .evaluation-title{
            color:#ffffff;
            font-size:30px;
            font-weight:bold;
            margin-top:71px;
        }
        .evaluation-desc{
            color:#cccccc;
            font-size:16px;
            margin-top:20px;
        }
        .evaluation-box{
            margin-top:81px;
            margin-bottom:106px;
            width:100%;
            .evaluation-list{
                // width:100%;
                padding:0 10%;
                display:flex;
                column-gap:45px;
                position:relative;
                .evaluation-item{
                    width:32%;
                    background:rgba(255,255,255,0.1);
                    border-radius:8px;
                    .item-container{
                        padding:30px 30px 59px 30px;
                        display:flex;
                        flex-direction:column;
                        row-gap:27px;
                        height:auto;
                        .user-info{
                            display:flex;
                            align-items:center;
                            column-gap:16px;
                            .user-avatar{
                                width:66px;
                                height:66px;
                                border-radius:50%;
                                object-fit:cover;
                                object-position:center;
                            }
                            .name-job{
                                display:flex;
                                flex-direction:column;
                                // row-gap:3px;
                                .name{
                                    color:#ffffff;
                                    font-size:18px;
                                    font-weight:bold;
                                }
                                .job{
                                    color:#ffffff;
                                    font-size:14px;
                                }
                            }
                        }
                        .score-box{
                            display:flex;
                            align-items:center;
                            column-gap:3px;
                            .score-icon{
                                width:17px;
                                height:15px;
                            }
                        }
                        .evaluation-content{
                            color:#ffffff;
                            font-size:16px;
                            // line-height: 1.5;
                            display: -webkit-box;
                            -webkit-line-clamp: 4;
                            /*! autoprefixer: ignore next */
                            -webkit-box-orient: vertical;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            // max-height: 6em; /* 4行 * 1.5行高 = 6em */
                            word-wrap:break-word;
                            word-break:break-all;
                            // position:relative;
                            // &::before,&::after{
                            //     content:'"';
                            //     color:#ffffff;
                            // }
                            // &::after{
                            //     position:absolute;
                            //     right:0;
                            //     top:calc(1.5em * 3);
                            // }
                        }
                    }
                }
                .page-container{
                    width:80%;
                    height:100%;
                    z-index:100;
                    position:absolute;
                    display:flex;
                    justify-content:space-between;
                    align-items:center;
                    .prev,.next{
                        width:40px;
                        height:40px;
                        background:rgba(255,255,255,0.2);
                        display:flex;
                        align-items:center;
                        justify-content:center;
                        border-radius:50%;
                        cursor:pointer;
                        .prev-icon,.next-icon{
                            width:24px;
                            height:24px;
                        }
                    }
                }
            }
        }
    }
    .cases-footer{
        width:100%;
        height:740px;
        background:url('../../assets/images/bg-cases-bottom.jpg');
        background-repeat:no-repeat;
        background-size:cover;
        background-position:center;
        display:flex;
        justify-content:center;
        .footer-center{
            margin-top:370px;
            width:1115px;
            height:260px;
            background:rgba(0,0,0,0.7);
            border-radius:15px;
            display:flex;
            flex-direction:column;
            justify-content:center;
            align-items:center;
            .main-slogan{
                color:#ffffff;
                font-size:30px;
                font-weight:bold;
                margin-top:35px;
            }
            .main-desc{
                color:#ffffff;
                font-size:16px;
                margin-top:20px;
            }
            .design-btn{
                width:210px;
                height:50px;
                line-height:50px;
                text-align:center;
                background:#ffffff;
                color:#fe4655;
                border-radius:10px;
                margin-top:40px;
                font-weight:500;
                font-size:18px;
                cursor:pointer;
            }
        }
    }
}
</style>